/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import {
	Component,
	OnInit,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy,
	Inject,
	PLATFORM_ID,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../core/service/config.service';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { WishlistService } from '../../../../core/wishlist/wishlist.service';
import _ from 'underscore';
import { ChatDialog } from '../../../../default/pages/social-hub-user/chat-popup/chat-popup.component';
import { ListsService } from '../../../../core/lists/lists.service';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-vendors-carousel-banner',
	templateUrl: './vendors-carousel-banner.component.html',
	styleUrls: ['./vendors-carousel-banner.component.scss']
})

export class VendorsCarouselBannerComponent implements OnInit, AfterViewInit, OnChanges {


	public config: SwiperConfigInterface = {};

	public imagePath: string;
	public currentRate = 2;
	public discountPrice = 20;
	public fiftyPercent = 50;
	public sidenavOpen = true;
	public currentUser: any;
	public subscriptions = [];
	public vendors = [];
	public categories = [];
	public index = 0;
	public dialogRef: any;
	public vendorAd;


	@Input('vendorPrefix') vendorPrefix = '';

	@Input('flagUrl') flagUrl = '';

	@Input('id') id = '';

	constructor(
		public dialog: MatDialog,
		public listSandbox: ListsSandbox,
		public snackBar: MatSnackBar,
		private configService: ConfigService,
		private router: Router,
		@Inject(DOCUMENT) private document,
		@Inject(PLATFORM_ID) private platformId: Object,
		private wishlistService: WishlistService,
		private titleService: Title,
		public listService: ListsService
	) { }


	ngOnInit() {
		this.imagePath = this.configService.getImageUrl();
		//	this.getFeaturedList();
		this.subscriptions.push(this.listSandbox.categoryList$?.subscribe(data => {
			this.categories = data;
		}));
		if (isPlatformBrowser(this.platformId)) {
			this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.getFeaturedList();
	}


	openChat(id) {
		if (this.currentUser) {
			this.dialogRef = this.dialog.open(ChatDialog, {
				data: {
					title: "Chat",
					id: id
				}
			});
			this.dialogRef.afterClosed().subscribe(result => {
				console.log(`Dialog result: ${result}`);
			});
		} else {
			this.router.navigate(['/auth/sign-in'])
		}
	}

	getVendorAd(vendor) {
		const params: any = {};
		params.vendorId = vendor.vendorId;
		this.subscriptions.push(this.listService.getVendorAd(params).subscribe(response => {
			vendor.vendorAd = response.data;
		}));
	}

	public addToWishList(vendor) {
		let currentUser: any;
		if (isPlatformBrowser(this.platformId)) {
			currentUser = JSON.parse(localStorage.getItem('storeUser'));
		}
		if (currentUser) {
			if (vendor.wishListStatus == 0) {
				vendor.wishListStatus = 1;
				this.subscriptions.push(this.wishlistService.addVendorWishlist({
					vendorId: vendor.vendorId
				}).subscribe((response) => {
					vendor.wishlistId = response.data.id;
					this.snackBar.open(response.message, '×', {
						panelClass: 'success',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
				}, err => {

				}));
			} else {
				vendor.wishListStatus = 0;
				this.subscriptions.push(this.wishlistService.deleteVendorWishlist({
					id: vendor.wishlistId
				}).subscribe((response) => {
					this.snackBar.open(response.message, '×', {
						panelClass: 'success',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
				}, err => {

				}));
			}

		} else {
			this.router.navigate(['/auth']);
		}

	}


	public filter(categorySlug) {
		this.listSandbox.getVendorList({ categoryslug: categorySlug });
	}

	public getFeaturedList() {
		this.listSandbox.getVendorList({ countryId: this.id });
		this.listSandbox.vendorList$.subscribe((data) => {

			for (let item of data) {
				this.getVendorAd(item)
			}
			this.vendors = data;
			if (this.vendorPrefix) {
				const index = _.findIndex(data, (item) => {
					return (item.vendorPrefixId === this.vendorPrefix);
				});
				const vendorData = _.find(data, (item) => {
					return (item.vendorPrefixId === this.vendorPrefix);
				});
				console.log(" vendorData ", vendorData);
				if (vendorData) {
					this.titleService.setTitle(`Marketplace - ${vendorData.companyName}`);
				}

				if (index >= 0) {
					this.index = index;
				}
			}
		})
	}


	ngOnDestroy() {
		this.subscriptions.forEach(each => each.unsubscribe());
	}


	navigate(vendor) {
		if (vendor.subdomain) {
			const url = this.configService.getSubdomainUrl().replace('{subdomain}', vendor.subdomain);
			this.document.location.href = url + '/vendor-detail/detail/' + vendor.vendorPrefixId + '?vendorId=' + vendor.vendorId;
		} else {
			this.router.navigate(['/vendor-detail/detail/', vendor.vendorPrefixId], {
				queryParams: {
					vendorId: vendor.vendorId
				}
			})
		}
	}


	ngAfterViewInit() {

		this.config = {
			direction: 'horizontal',
			observer: true,
			slidesPerView: 1,
			spaceBetween: 0,
			keyboard: true,
			loop: true,
			navigation: true,
			pagination: false,
			grabCursor: false,
			autoplay: false,
			speed: 900,
			effect: 'slide',

			breakpoints: {
				510: {
					slidesPerView: 1
				},
				850: {
					slidesPerView: 1
				},
				1100: {
					slidesPerView: 1
				},
				1280: {
					slidesPerView: 1
				},
				1300: {
					slidesPerView: 1
				},
				1500: {
					slidesPerView: 1
				}
			}
		};
	}
}
